import { t } from "i18next";

import nftPlaceholder from "@/assets/icons/nft.svg";
import { Button } from "@/components/Button";
import { T_ME_HAPI_ANN } from "@/constants";
import { useAirdrops, useStore } from "@/hooks/store";

import styles from "./styles";

type EmptyType = "checkNews" | "mint" | "buy" | "wait";

const getEmptyType = (
  props: {
    isPurchased: boolean;
    isSoldOut: boolean;
    unlocked: boolean;
    airdropsCount: number;
    userNftsCount: number;
  } | null,
): EmptyType => {
  if (!props) return "checkNews";
  if (!props.isPurchased && !props.isSoldOut) return "mint";
  if (props.userNftsCount > 0 && props.airdropsCount === 0) return "wait";
  if (props.isSoldOut && props.unlocked) return "buy";
  return "checkNews";
};

const Footer = ({ type }: { type: EmptyType }) => {
  switch (type) {
    case "mint":
    case "buy":
      return (
        <>
          <styles.Text>
            <p>{t("Airdrop.MissingNFT")}</p>
            <p>{t("Airdrop.GetOn", { marketplace: "HOT Craft" })}</p>
          </styles.Text>
          <Button
            name="BuyNFTOn"
            additionalDataForName={{ marketplace: "HOT Craft" }}
            handler={() => window.open("https://hotcraft.art/collection/hapi-nearonaut.near")}
          />
        </>
      );

    case "wait":
      return (
        <>
          <styles.Text>
            <p>{t("Airdrop.AirdropNotAvailable")}</p>
            <p>{t("Airdrop.StayTunedForFurtherUpdates")}</p>
          </styles.Text>
          <Button name="CheckNews" type="news" handler={() => window.open(T_ME_HAPI_ANN)} />
        </>
      );

    case "checkNews":
      return (
        <>
          <styles.Text>
            <p>{t("Airdrop.NFTIsNotAvailable")}</p>
            <p>{t("Airdrop.StayTunedForFurtherUpdates")}</p>
          </styles.Text>
          <Button name="CheckNews" type="news" handler={() => window.open(T_ME_HAPI_ANN)} />
        </>
      );

    default:
      return null;
  }
};

export const EmptyNFTs = () => {
  const { currentNetworkData } = useStore((store) => ({
    currentNetworkData: store.user.networksData[store.network],
  }));
  const airdrops = useAirdrops((store) => store.airdrops[currentNetworkData.network]);
  const airdropsArray = Object.values(airdrops ?? {});
  const userNfts = currentNetworkData.nft;

  const type = getEmptyType(
    userNfts
      ? {
          isPurchased: userNfts.isPurchased,
          isSoldOut: userNfts.isSoldOut,
          unlocked: Date.now() > userNfts.nftUnlockDate,
          airdropsCount: airdropsArray.length,
          userNftsCount: userNfts.array.length,
        }
      : null,
  );

  return (
    <styles.Container>
      <styles.NFTContainer>
        <img src={nftPlaceholder} alt="nftPlaceholder" />
      </styles.NFTContainer>
      <Footer type={type} />
    </styles.Container>
  );
};
